import LabelProvider from "core/components/label/LabelProvider";
export default LabelProvider.create({

	LaunchCourse: {
		k: "product.launch",
		v: "Launch Course"
	}
});



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/OrganizationProducts.labels.ts